module.exports = __webpack_public_path__ + "static/media/jun.2ba5d882.png";